<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="carregarDocumentos($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-proprietarios-documentos [documentos]="documentos$ | async" [alteracoes]="alteracoes$ | async"></usucampeao-proprietarios-documentos>
</ion-content>
